import React from 'react'
import styled from 'styled-components'
import Slide from './Slide'
import Wildwest from './Images/WildWest Ballers.jpg'
import Underdogs from './Images/The Underdogs.jpg'
import Mavericks from './Images/Travis Mavericks Logo.png'
import Doodles from './Images/Just Doodles.jpg'
import Ace from './Images/TEAM ACE LOGO.png'
import Kpako from './Images/Kpako BC.jpg'
import Ringerz from './Images/Ringerz.png'

function Hero() {
  return (
    <HeroMain>
      <HeroTop></HeroTop>
      <HeroContain>
        <HeroLeft>
          <HeroLeftContain>
            <Slide/>
          </HeroLeftContain>
        </HeroLeft>
        <HeroRight>
          <HeroRightContain>
            <HeroRightUp>
              <HeroRightUpContain>
                <ListContain>
                  <h3>Headlines</h3>
                  <hr/>
                  <ul>
                    <li>1st game: 17/9</li>
                    <li>Teams: 8</li>
                    <li>Players: 96</li>
                    <li>Logo: Dr. Ayo</li>
                  </ul>
                </ListContain>
              </HeroRightUpContain>
            </HeroRightUp>
            <HeroRightDown>
              <HeroRightDownContain>
                <ListContain>
                  <h3>Fixtures</h3>
                  <hr/>
                  <ol>
                    <li><img src={Mavericks} alt='img'/> vs <img src={Underdogs} alt='img'/></li>
                    <li><img src={Ringerz} alt='img'/> vs <img src={Kpako} alt='img'/></li>
                    <li><img src={Ace} alt='img'/> vs <img src={Kpako} alt='img'/></li>
                    <li><img src={Wildwest} alt='img'/> vs <img src={Doodles} alt='img'/></li>
                    <li><img src={Ace} alt='img'/> vs <img src={Underdogs} alt='img'/></li>
                    <li><img src={Underdogs} alt='img'/> vs <img src={Doodles} alt='img'/></li>
                  </ol>
                </ListContain>  
              </HeroRightDownContain>
            </HeroRightDown>
          </HeroRightContain>
        </HeroRight>
      </HeroContain>
      <HeroTop></HeroTop>
    </HeroMain>  
  )
}

export default Hero

const HeroMain = styled.div`
width: 100%;
background-color: antiquewhite;
`

const HeroTop = styled.div`
width: 100%;
height: 15vh;
`

const HeroContain = styled.div`
width: 100%;
height: 70vh;
display: flex;
@media screen and (max-width: 750px) {
  height: 50vh;
}
`

const HeroLeft= styled.div`
width: 70%;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
`

const HeroRight = styled.div`
width: 30%;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
`

const HeroLeftContain = styled.div`
height: 95%;
width: 90%;
`

const HeroRightContain = styled.div`
height: 95%;
width: 90%;
img {
  height: 30px;
  width: 30px;
  @media screen and (max-width: 750px) {
    height: 15px;
    width: 15px;    
  }
}
`

const HeroRightUp = styled.div`
height: 50%;
width: 100%;
display: flex;
justify-content: center;
align-items: start;
`

const HeroRightDown = styled.div`
height: 50%;
width: 100%;
display: flex;
justify-content: center;
align-items: end;
text-align: center;
li{
  display: flex;
  justify-content: space-around;
}
`

const HeroRightUpContain = styled.div`
height: 95%;
width: 90%;
background-color: white;
display: flex;
justify-content: center;
align-items: center;
`

const HeroRightDownContain = styled.div`
height: 95%;
width: 90%;
background-color: white;
display: flex;
justify-content: center;
align-items: center;
`

const ListContain = styled.div`
width: 60%;
height: 95%;
display: flex;
flex-direction: column;
justify-content: space-around;
@media screen and (max-width: 850px) {
  font-size: 10px;
}
`